import Vue from 'vue';

import Fragment from 'vue-fragment';
Vue.use(Fragment.Plugin);

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);

import App from './App.vue';
import router from './router';

import '@/assets/scss/style.scss';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faGlobeAmericas, faQuestionCircle, faPowerOff, faTerminal, faInfo } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faGlobeAmericas, faTwitter, faDiscord, faQuestionCircle, faPowerOff, faTerminal, faInfo);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

import axios from './axios.js';
Vue.prototype.$http = axios;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
